var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.calculateStyle),expression:"calculateStyle"}],staticClass:"loader mx-auto text-xs-center"},[_c('div',{staticClass:"backdrop"}),_c('v-progress-linear',{staticClass:"progress ma-auto",style:(_vm.style),attrs:{"indeterminate":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }